import { CellPlugin } from '@react-page/editor';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

// use a type here, not an interface
type Data = {
  label: string,
  value: string
}

const getValue = (value: string) => {
  if (value && value.length > 0) {
    if (value === "CreditCard") {
      return "Credit Card";
    }
    return value;
  } else {
    return "Credit Card";
  }
}

const PaymentTypePropertyPlugin: CellPlugin<Data> = {
  Renderer: ({ data }) => (
      <Row>
        <Col><strong>{data.label}</strong></Col>
        <Col>{getValue(data.value)}</Col>
      </Row>
  ),
  id: 'paymentTypePropertyPlugin',
  title: 'Payment Type Property',
  description: 'Payment Type Property.',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      properties: {
        label: {
          type: 'string',
          default: 'Payment Type',
        },
      },
      required: ['label'],
    },
  },
};

export default PaymentTypePropertyPlugin;